import Vue from "vue";
import moment from "moment";

Vue.filter("formatDate", function(date, format = "YYYY.MM.DD") {
  return moment(date).format(format);
});
Vue.filter("formatShortDate", function(date, format = "YYYY.MM.DD") {
  return moment(date).format(format);
});

Vue.filter("formatMoney", function(value) {
  const intVal = Math.trunc(value);
  const tizedek = (Number(value) - Number(intVal)).toFixed(2);
  let tizedekText = "";
  if (tizedek != "0.00") {
    tizedekText = tizedek.toString().substring(1);
  }
  if (intVal) {
    const stringValue = intVal.toString();
    if (stringValue && stringValue.length > 0) {
      const arr = [];
      let string = "";
      for (let i = stringValue.length - 1; i >= 0; i--) {
        string = stringValue.charAt(i).concat(string);
        if (string.length % 3 === 0) {
          arr.push(string);
          string = "";
        }
      }
      arr.push(string);
      return arr.reverse().join(" ") + tizedekText + " Ft";
    }
  }
  return "0 Ft";
});

Vue.filter("roundingMoney", function(value) {
  const lastNum = Number(value.toString().slice(-1));
  if (lastNum < 2.5) {
    return value - lastNum;
  } else if (lastNum > 2.5 && lastNum < 5) {
    return value + (5 - lastNum);
  } else if (lastNum > 5 && lastNum < 7.5) {
    return value - (lastNum - 5);
  } else if (lastNum > 7.5) {
    return value + (10 - lastNum);
  } else {
    return value;
  }
});

Vue.filter("formatWorkedTime", function(value) {
  const hours = Math.floor(value);
  const minutes = Math.round((value - hours) * 60);
  return `${hours} óra ${minutes} perc`;
});

Vue.filter("formatDays", function(value) {
  return `${value} nap`;
});

Vue.filter("tableFilter", function(value) {
  if (value) {
    return value;
  } else {
    return "-";
  }
});
